export default class Status {
    constructor({
        id = 0,
        statusTypeId = 0,
        name = null,
        createdAt = new Date(),
        updatedAt = new Date()
    } = {}) {
        this.id = id;
        this.statusTypeId = statusTypeId;
        this.name = name;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}
